export default {
  tradeLane: {
    showOriginBillingLink: true,
    warRestrictedZones: ["BY", "RU"],
    partialWarRestrictedZones: ["UA"],
    laborDisruptionsZones: ["NL", "BE", "ES", "PT", "DE", "CA"],
  },
  shipmentLane: {
    business: {
      settingsDangerousGoods: true,
      quantitySelector: true,
      addItem: true,
      maxNumberOfShipmentItems: 5,
    },
    private: {
      settingsDangerousGoods: false,
      quantitySelector: false,
      addItem: false,
      maxNumberOfShipmentItems: 5,
    },
  },
  offersLane: {
    // This applies to only DGF offers
    serviceSuspensionZones: ["BY", "RU", "SD", "IL"],
    emergencySurchargeUnit: "OFR",
    business: {
      enableTeaserOverlayFeature: false,
    },
    private: {
      enableTeaserOverlayFeature: false,
    },
  },
  shipmentDayRange: 6, // In days
};
